import React, { Component } from 'react';
import python from "./images/buttons/python_logo.svg"
import reactpng from "./images/buttons/react_icon.svg"
import DocsFrontEnd from './DocsFrontEnd'
import DocsBackEnd from './DocsBackEnd'

class Docs2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Docs:"FrontEnd"
    };
  }
  
  changeState = (newState) => {
    this.setState({
      Docs:newState
    });
  }

  render() {
    const chooserStyle = {
      height:"auto",
      margin:"0px",
      display:"flex",
      justifyContent:"center",
      width:"100%"
    }
    const chooser2Style = {
      margin:"0px",
      display:"flex",
      justifyContent:"center",
      backgroundColor:"#606060",
      borderRadius:"10px"
    }
    const chooserImgStyle = {
      width:"40px",
      margin:"5px 15px",
      padding:"10px",
      borderRadius:"10px"
    }
    const chooserImgSelectedStyle = {
      ...chooserImgStyle,
      backgroundColor:"#808080"
    }

    console.log(chooserImgStyle);
    
    return(
      <>
        <a href='https://moreygenetics.com'>
          <span style={{fontSize:'35px'}}>&#x2B05;</span>
        </a>
        <div style={chooserStyle}>
          <div style={chooser2Style}>
            <img onClick={()=>this.changeState("FrontEnd")}
              style={(this.state.Docs==="FrontEnd" ? chooserImgSelectedStyle : chooserImgStyle)}
              src={reactpng} alt='react'/>
            <img onClick={()=>this.changeState("BackEnd")}
              style={(this.state.Docs==="BackEnd" ? chooserImgSelectedStyle : chooserImgStyle)}
              src={python} alt='python'/>
          </div>
        </div>
        <br/>
        <div>
          {(this.state.Docs==="BackEnd")&&<DocsBackEnd/>}
          {(this.state.Docs==="FrontEnd")&&<DocsFrontEnd/>}
        </div>
      </>
    )
  }
}

export default Docs2;